export const trafficMethodsTypes = {
  loading: 'trafficMethods/loading',
  success: 'trafficMethods/success',
  error: 'trafficMethods/error',
};
